import React from "react";
import { Link } from "react-router-dom";

export default ({ children, items = [] }) => {
  const [isOpen, toggle] = React.useReducer(s => !s, false);
  return (
    <div className="menu">
      <span className="menu_label" onClick={toggle}>
        {children}
      </span>
      {isOpen && (
        <div className="menu_overlay">
          {items.map((item, index) => {
            if (item.to)
              return (
                <Link
                  className="menu_link"
                  to={item.to}
                  key={index}
                  onClick={toggle}
                >
                  <h5>{item.label}</h5>
                </Link>
              );
            else
              return (
                <button
                  className="menu_link"
                  key={index}
                  onClick={item.onClick}
                >
                  <h5>{item.label}</h5>
                </button>
              );
          })}
        </div>
      )}
    </div>
  );
};
